document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('backinstock-modal-overlay');
  var modal = document.getElementById('backinstock-modal');

  // Save original modal markup so we can restore later
  var ORIGINAL_MODAL_HTML = modal ? modal.innerHTML : '';

  // These will be re-bound whenever we restore modal HTML
  var modalTitle = document.getElementById('backinstock-modal-title-text');
  var btnCancel = document.getElementById('backinstock-modal-cancel');
  var btnOK = document.getElementById('backinstock-modal-ok');

  // Works on product + collection pages
  var subscribeButtons = document.querySelectorAll('.subscribe-notify');

  var prevBodyOverflow = '';
  var prevHtmlOverflow = '';
  var activeVariantId = null;
  var activeCompanyId = null;

  // Loader element (overlayed on top of modal)
  var loaderEl = null;

  function createLoader() {
    if (!overlay || loaderEl) return;

    loaderEl = document.createElement('div');
    loaderEl.id = 'backinstock-modal-loader';
    loaderEl.style.position = 'absolute';
    loaderEl.style.inset = '0';
    loaderEl.style.display = 'none';
    loaderEl.style.alignItems = 'center';
    loaderEl.style.justifyContent = 'center';
    loaderEl.style.background = 'rgba(255, 255, 255, 0.6)';
    loaderEl.style.zIndex = '100000';

    loaderEl.innerHTML = `
      <img
        src="https://cdn.shopify.com/s/files/1/0865/9809/1054/files/add_loading.gif"
        alt="Loading..."
        style="height: 40px;"
      />
    `;

    overlay.style.position = overlay.style.position || 'fixed';
    overlay.appendChild(loaderEl);
  }

  function showLoader() {
    createLoader();
    if (loaderEl) loaderEl.style.display = 'flex';
  }

  function hideLoader() {
    if (loaderEl) loaderEl.style.display = 'none';
  }

  function openModal() {
    if (!overlay) return;
    prevBodyOverflow = document.body.style.overflow;
    prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    overlay.style.display = 'flex';
  }

  function closeModal() {
    if (!overlay) return;
    overlay.style.display = 'none';
    document.body.style.overflow = prevBodyOverflow;
    document.documentElement.style.overflow = prevHtmlOverflow;

    activeVariantId = null;
    activeCompanyId = null;

    hideLoader();

    // re-enable OK if exists
    var ok = document.getElementById('backinstock-modal-ok');
    if (ok) ok.disabled = false;
  }

  // Restore original modal content + rebind listeners
  function restoreOriginalModal() {
    if (!modal) return;

    modal.innerHTML = ORIGINAL_MODAL_HTML;

    // Re-query elements because innerHTML reset recreates nodes
    modalTitle = document.getElementById('backinstock-modal-title-text');
    btnCancel = document.getElementById('backinstock-modal-cancel');
    btnOK = document.getElementById('backinstock-modal-ok');

    bindCancelButton();
    bindOkButton();
  }

  // Get currently selected variant (ONLY used as fallback if button has no data-variant-id)
  function getCurrentlySelectedVariantId() {
    var selectEl = document.querySelector('select[id^="ProductSelect-"]');
    if (selectEl && selectEl.value) return selectEl.value;

    // safer fallback: prefer the first product form’s variant id, not random quick-add inputs
    var productForm = document.querySelector('form[action^="/cart/add"]');
    if (productForm) {
      var hiddenId = productForm.querySelector('input[name="id"]');
      if (hiddenId && hiddenId.value) return hiddenId.value;
    }

    return null;
  }

  // Decide which variantId to use based on the clicked button
  function resolveVariantIdFromButton(btn) {
    // ✅ ALWAYS trust the clicked button first (works perfectly on collection pages)
    var btnVariantId = btn.getAttribute('data-variant-id');
    if (btnVariantId) return btnVariantId;

    // fallback for product pages if button doesn't carry variant id
    return getCurrentlySelectedVariantId();
  }

  function bindCancelButton() {
    if (!btnCancel) return;
    btnCancel.onclick = function () {
      closeModal();
    };
  }

  function bindOkButton() {
    if (!btnOK) return;

    btnOK.onclick = function () {
      if (!activeVariantId || !activeCompanyId) {
        console.error('No active variant/company selected');
        return;
      }

      btnOK.disabled = true;
      showLoader();

      var formData = new FormData();
      formData.append('variant_id', activeVariantId);
      formData.append('company_id', activeCompanyId);

      fetch('https://king-prawn-app-l7ked.ondigitalocean.app/public/backinstock-subscribe', {
        method: 'POST',
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.text();
        })
        .then(function () {
          hideLoader();

          if (!modal) return;

          modal.innerHTML = `
            <h2 id="modal-close-h2">Subscribed!</h2>
            <p id="modal-close-p">You will be notified once this product is back in stock.</p>
            <button type="button" id="backinstock-modal-close-ok">Okay</button>
          `;

          var closeOkBtn = document.getElementById('backinstock-modal-close-ok');
          if (closeOkBtn) {
            closeOkBtn.addEventListener('click', function () {
              // ✅ restore modal back to subscribe/cancel state for next product
              restoreOriginalModal();
              closeModal();

              // If you want a hard refresh instead, use:
              // window.location.reload();
            });
          }
        })
        .catch(function (err) {
          console.error('Subscription failed:', err);
          hideLoader();
          alert('Failed to subscribe, please try again later.');
          var ok = document.getElementById('backinstock-modal-ok');
          if (ok) ok.disabled = false;
        });
    };
  }

  // Bind initial listeners
  bindCancelButton();
  bindOkButton();

  // Click outside modal to close
  if (overlay) {
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        restoreOriginalModal();
        closeModal();
      }
    });
  }

  // Attach click handlers to ALL buttons (collection + product)
  if (subscribeButtons && subscribeButtons.length > 0) {
    subscribeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();

        // Always restore modal to original state before opening
        restoreOriginalModal();

        // ✅ THIS is what makes collection page correct:
        // we resolve variant from the clicked button itself
        var vId = resolveVariantIdFromButton(btn);
        var cId = btn.getAttribute('data-company-id');
        var pTitle = btn.getAttribute('data-product-title');

        if (!vId || !cId) {
          console.error('Missing variant or company ID on button', { vId: vId, cId: cId });
          return;
        }

        activeVariantId = vId;
        activeCompanyId = cId;

        if (modalTitle && pTitle) {
          modalTitle.textContent = pTitle;
        }

        openModal();
      });
    });
  }
});
